var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"clearfix mb-0"},[_c('span',{staticClass:"float-md-left d-block d-md-inline-block mt-25"},[_vm._v(" "+_vm._s(_vm.$t('COPYRIGHT'))+" © "+_vm._s(new Date().getFullYear())+" "),_c('span',{staticClass:"d-none d-sm-inline-block"},[_vm._v("Enably, "+_vm._s(_vm.$t('All rights Reserved')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }